<template>
  <div>
    <v-checkbox class="mt-0" v-model="donationEnabled" color="primary">
      <template v-slot:label>
        <div>
          <b>Enable Donation</b>
        </div>
      </template>
      <template v-slot:append>
        <v-tooltip top color="white">
          <template v-slot:activator="{ on }">
            <v-icon v-on="on">mdi-information-outline</v-icon>
          </template>
          <div class="grey--text text--darken-3 body-1">
            {{ $t("paypal_donation.subtitle") }}
          </div>
        </v-tooltip>
      </template>
    </v-checkbox>
    <template v-if="donationEnabled">
      <v-text-field
        :label="$t('paypal_donation.fields.email')"
        v-model="donation.email"
        :rules="[rules.required, rules.email]"
      ></v-text-field>
      <v-text-field
        :label="$t('paypal_donation.fields.purpose')"
        :placeholder="$t('paypal_donation.fields.purpose.placeholder')"
        v-model="donation.purpose"
      ></v-text-field>
    </template>
  </div>
</template>
<script>
import rules from "@/validation";
export default {
  name: "PaypalDonation",
  props: ["donation_enabled", "donation"],
  data() {
    return {
      rules,
    };
  },
  computed: {
    donationEnabled: {
      get: function () {
        return this.donation_enabled;
      },
      set: function (value) {
        this.$emit("update:donation_enabled", value);
      },
    },

    localDonation: {
      get: function () {
        return this.donation;
      },
      set: function (value) {
        this.$emit("update:donation", value);
      },
    },
  },
};
</script>
